import React, {useEffect, useState} from 'react';
import ReactDOM from 'react-dom';
import { Button, Card, CardBody } from 'reactstrap';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import CalendarToolbar from '../CalendarToolbar'
import _moment from '../../libs/moment';
import { isAndroidOrIos } from '../../helpers/Utils';

const CustomCalendar = (props) => {
  const [data, setData] = useState([])
  const [diff, setDiff] = useState(0)
  const [prevDiff, setPrevDiff] = useState(0)
  const {ctxCruGrid, L} = props
  const localizer = momentLocalizer(_moment)

  useEffect(() => {
    const remapData = () => {
      let data = props.ctxCruGrid.state.data
      data = data.map(item => {
        // Convert server datetime (GMT-5) to browser local time before rendering.
        const startMoment = _moment(item.startDate).utcOffset(-5, true).local()
        const endMoment = _moment(item.endDate).utcOffset(-5, true).local()
        const start = startMoment.toDate()
        const end = endMoment.toDate()
        const startsAtLocalMidnight = start.getHours() === 0 && start.getMinutes() === 0
        const spansMoreThanOneLocalDay = _moment(start).startOf('day').valueOf() !== _moment(end).startOf('day').valueOf()
        const isFullSingleLocalDay = end.getHours() === 23
        const isAllday = startsAtLocalMidnight && (spansMoreThanOneLocalDay || isFullSingleLocalDay)
        item = {
          id: item.ID,
          title: item.name,
          allDay: isAllday,
          start: start,
          end: end,
          titleHtml: `${!isAllday ? `<strong>${startMoment.format('HH:mm ')}</strong>` : ''}${item.name}`
        }
        return item
      })
      setData(data)
    }
    remapData()
  }, [props])

  useEffect(() => {
    setPrevDiff(diff)
  }, [diff])

  useEffect(() => {
    if (prevDiff !== diff) {
      ctxCruGrid.view.config.customPathGet = `admActivity/month/${diff}`
      ctxCruGrid.getData()
    }
  }, [prevDiff, diff, ctxCruGrid])

  const onNavigate = (date) => {
    const currentMonth = _moment().startOf('month')
    const selectedMonth = _moment(date).startOf('month')
    const diff = selectedMonth.diff(currentMonth, 'months')
    setDiff(diff)
  }

  const onSelectEvent = (e) => {
    if (!isAndroidOrIos()) ctxCruGrid.getDataById(e.id)
  }

  const onSelectSlot = (e) => {
    const serverDateFormat = 'YYYY-MM-DD HH:mm:ss'
    const slotStart = _moment(e.start)
    const selectedEnd = _moment(e.end)
    const selectedDurationMinutes = Math.max(selectedEnd.diff(slotStart, 'minutes'), 0)
    const slotEnd = selectedDurationMinutes < 60
      ? slotStart.clone().add(1, 'hours')
      : selectedEnd

    ctxCruGrid.state.formFields.map(f => {
      if (f.name === 'startDate') f.value = slotStart.clone().utcOffset(-5, false).format(serverDateFormat)
      if (f.name === 'endDate') f.value = slotEnd.clone().utcOffset(-5, false).format(serverDateFormat)
      return f
    })
    ctxCruGrid.toggle()
  }

  const ContexMenu = (event) => {
    return <div className="dropdown-menu show">
      <button type="button" className="dropdown-item" onClick={() => { ctxCruGrid.getDataById(event.id) }}><i className='simple-icon-pencil'></i>{L['main.edit']}</button>
      <button type="button" className="dropdown-item" onClick={() => { ctxCruGrid.toggleDelete(event.id) }}><i className='simple-icon-trash'></i>{L['main.delete']}</button>
    </div>
  }

  const showMenu = (e, event) => {
    e.preventDefault()
    var menus = document.querySelectorAll('.rbc-event-context-menu')
    menus.forEach(function(menu) {
      menu.parentNode.removeChild(menu)
    })
    var div = document.createElement('div')
    div.classList.add('rbc-event-context-menu')
    div.style.top = e.clientY + window.scrollY + 'px';
    div.style.left = e.clientX + window.scrollX + 'px';
    ReactDOM.render(<ContexMenu {...event}></ContexMenu>, div);
    document.body.appendChild(div)
    div.addEventListener('click', function() {
      if (document.body.contains(div)) document.body.removeChild(div)
    })
    div.addEventListener('mouseleave', function() {
      if (document.body.contains(div)) document.body.removeChild(div)
    })
    document.addEventListener('click', function(event) {
      if (!event.target.classList.contains('rbc-event-context-menu') && document.body.contains(div)) {
        document.body.removeChild(div)
      }
    }, { once: true })
  }

  const eventWrapperComponent = ({ event, children }) => (
    <div
      onClick={
        e => {
          if (isAndroidOrIos()) showMenu(e, event)
        }
      }
      onContextMenu={
        e => {
          if (!isAndroidOrIos()) showMenu(e, event)
        }
      }
    >
      {children}
    </div>
  )

  const eventComponent = ({ event }) => (
    <div className='text-left' dangerouslySetInnerHTML={{ __html: event.titleHtml }} />
  )

  const now = new Date()

  const dayStyleGetter = date => {
    if (_moment(date).isSame(now, 'day')) {
      return {
        className: 'rbc-highlight-today'
      }
    }
    return {}
  }

  return (
    <div>
      <Button size="sm" className="mb-3 d-block d-sm-none" color="primary" onClick={ctxCruGrid.toggle}>{L["main.create"]}</Button>
      <Card className={"mb-4"}>
        {ctxCruGrid.state.progressBar && <div className="progress"><div className="indeterminate"></div></div>}
        <CardBody>
          <Calendar
            localizer={localizer}
            action={'select'}
            events={data}
            views={['day','week','month']}
            defaultDate={new Date()}
            selectable
            // showAllEvents
            onSelectEvent={onSelectEvent}
            onSelectSlot={onSelectSlot}
            onNavigate={onNavigate}
            dayPropGetter={dayStyleGetter}
            components={
              {
                toolbar : toolbar => <CalendarToolbar {...toolbar} toggle={ctxCruGrid.toggle} L={L}/>,
                eventWrapper: eventWrapperComponent,
                event: eventComponent
              }
            }
            formats={
              {
                monthHeaderFormat: (date, culture, localizer) => `${localizer.format(date, 'MMMM YYYY', culture)}`.toUpperCase(),
                dayHeaderFormat: (date, culture, localizer) => `${localizer.format(date, 'DD MMMM YYYY', culture)}`.toUpperCase(),
                dayRangeHeaderFormat: ({ start, end }, culture, localizer) => `${localizer.format(start, 'DD MMMM', culture)} - ${localizer.format(end, 'DD MMMM', culture)}`.toUpperCase()
              }
            }
          />
        </CardBody>
      </Card>
    </div>
  )
}
export default CustomCalendar